export const POST_EMPLOYEE_DETAILS_REQUEST = "POST_EMPLOYEE_DETAILS_REQUEST";
export const POST_EMPLOYEE_DETAILS_SUCCESS = "POST_EMPLOYEE_DETAILS_SUCCESS";
export const POST_EMPLOYEE_DETAILS_FAIL = "POST_EMPLOYEE_DETAILS_FAIL";

export const POST_EMPLOYEE_QUALIFICATIONS_REQUEST ="POST_EMPLOYEE_QUALIFICATIONS_REQUEST";
export const POST_EMPLOYEE_QUALIFICATIONS_SUCCESS ="POST_EMPLOYEE_QUALIFICATIONS_SUCCESS";
export const POST_EMPLOYEE_QUALIFICATIONS_FAIL ="POST_EMPLOYEE_QUALIFICATIONS_FAIL";

export const POST_EMPLOYEE_DEPENDENTS_REQUEST ="POST_EMPLOYEE_DEPENDENTS_REQUEST";
export const POST_EMPLOYEE_DEPENDENTS_SUCCESS ="POST_EMPLOYEE_DEPENDENTS_SUCCESS";
export const POST_EMPLOYEE_DEPENDENTS_FAIL = "POST_EMPLOYEE_DEPENDENTS_FAIL";

export const POST_PREVIOUS_EMPLOYMENT_REQUEST ="POST_PREVIOUS_EMPLOYMENT_REQUEST";
export const POST_PREVIOUS_EMPLOYMENT_SUCCESS ="POST_PREVIOUS_EMPLOYMENT_SUCCESS";
export const POST_PREVIOUS_EMPLOYMENT_FAIL = "POST_PREVIOUS_EMPLOYMENT_FAIL";

export const POST_WORKPLACE_RELATIONSHIPS_REQUEST ="POST_WORKPLACE_RELATIONSHIPS_REQUEST";
export const POST_WORKPLACE_RELATIONSHIPS_SUCCESS ="POST_WORKPLACE_RELATIONSHIPS_SUCCESS";
export const POST_WORKPLACE_RELATIONSHIPS_FAIL = "POST_EMPLOYEE_DETAILS_FAIL";

// GET METHODS
export const GET_EMPLOYEE_DETAILS_BY_USER_REQUEST= "GET_EMPLOYEE_DETAILS_BY_USER_REQUEST";
export const GET_EMPLOYEE_DETAILS_BY_USER_SUCCESS= "GET_EMPLOYEE_DETAILS_BY_USER_SUCCESS";
export const GET_EMPLOYEE_DETAILS_BY_USER_FAIL= "GET_EMPLOYEE_DETAILS_BY_USER_FAIL";

export const GET_EMPLOYEE_QUALIFICATIONS_REQUEST = "GET_EMPLOYEE_QUALIFICATIONS_REQUEST";
export const GET_EMPLOYEE_QUALIFICATIONS_SUCCESS = "GET_EMPLOYEE_QUALIFICATIONS_SUCCESS";
export const GET_EMPLOYEE_QUALIFICATIONS_FAIL = "GET_EMPLOYEE_QUALIFICATIONS_FAIL";

export const GET_EMPLOYEE_DEPENDENTS_REQUEST = "GET_EMPLOYEE_DEPENDENTS_REQUEST";
export const GET_EMPLOYEE_DEPENDENTS_SUCCESS = "GET_EMPLOYEE_DEPENDENTS_SUCCESS";
export const GET_EMPLOYEE_DEPENDENTS_FAIL = "GET_EMPLOYEE_DEPENDENTS_FAIL";

export const GET_PREVIOUS_EMPLOYMENT_REQUEST = "GET_PREVIOUS_EMPLOYMENT_REQUEST";
export const GET_PREVIOUS_EMPLOYMENT_SUCCESS = "GET_PREVIOUS_EMPLOYMENT_SUCCESS";
export const GET_PREVIOUS_EMPLOYMENT_FAIL = "GET_PREVIOUS_EMPLOYMENT_FAIL";

export const GET_WORKPLACE_RELATIONSHIP_REQUEST = "GET_WORKPLACE_RELATIONSHIP_REQUEST";
export const GET_WORKPLACE_RELATIONSHIP_SUCCESS = "GET_WORKPLACE_RELATIONSHIP_SUCCESS";
export const GET_WORKPLACE_RELATIONSHIP_FAIL = "GET_WORKPLACE_RELATIONSHIP_FAIL";

export const GET_EMPLOYEE_BY_SERVICENO_REQUEST = "GET_EMPLOYEE_BY_SERVICENO_REQUEST";
export const GET_EMPLOYEE_BY_SERVICENO_SUCCESS = "GET_EMPLOYEE_BY_SERVICENO_SUCCESS";
export const GET_EMPLOYEE_BY_SERVICENO_FAIL = "GET_EMPLOYEE_BY_SERVICENO_FAIL";